"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getServerConfig = void 0;
const config_1 = __importDefault(require("@mapmaker/config"));
let serverConfigFetch = null;
let serverConfigCached = null;
function getServerConfig(ignoreCache = false) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!ignoreCache && serverConfigCached) {
            return serverConfigCached;
        }
        if (!serverConfigFetch) {
            serverConfigFetch = fetchServerConfig();
        }
        serverConfigCached = yield serverConfigFetch;
        return serverConfigCached;
    });
}
exports.getServerConfig = getServerConfig;
function fetchServerConfig() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`${config_1.default.apiGateway.url}/config`, {
            cache: "no-cache",
        });
        const config = yield response.json();
        return Object.assign(Object.assign({}, config), { date: config.date ? new Date(config.date) : new Date(), _retrievedAt: new Date() });
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VydmVyQ29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NsaWVudC9zZXJ2ZXJDb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsOERBQThDO0FBTzlDLElBQUksaUJBQWlCLEdBQWtDLElBQUksQ0FBQztBQUM1RCxJQUFJLGtCQUFrQixHQUFHLElBQUksQ0FBQztBQUU5QixTQUFzQixlQUFlLENBQ25DLGNBQXVCLEtBQUs7O1FBRTVCLElBQUksQ0FBQyxXQUFXLElBQUksa0JBQWtCLEVBQUU7WUFDdEMsT0FBTyxrQkFBa0IsQ0FBQztTQUMzQjtRQUNELElBQUksQ0FBQyxpQkFBaUIsRUFBRTtZQUN0QixpQkFBaUIsR0FBRyxpQkFBaUIsRUFBRSxDQUFDO1NBQ3pDO1FBQ0Qsa0JBQWtCLEdBQUcsTUFBTSxpQkFBaUIsQ0FBQztRQUM3QyxPQUFPLGtCQUFrQixDQUFDO0lBQzVCLENBQUM7Q0FBQTtBQVhELDBDQVdDO0FBRUQsU0FBZSxpQkFBaUI7O1FBQzlCLE1BQU0sUUFBUSxHQUFHLE1BQU0sS0FBSyxDQUFDLEdBQUcsZ0JBQWMsQ0FBQyxVQUFVLENBQUMsR0FBRyxTQUFTLEVBQUU7WUFDdEUsS0FBSyxFQUFFLFVBQVU7U0FDbEIsQ0FBQyxDQUFDO1FBQ0gsTUFBTSxNQUFNLEdBQUcsTUFBTSxRQUFRLENBQUMsSUFBSSxFQUFFLENBQUM7UUFDckMsT0FBTyxnQ0FDRixNQUFNLEtBQ1QsSUFBSSxFQUFFLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksSUFBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSSxJQUFJLEVBQUUsRUFDdEQsWUFBWSxFQUFFLElBQUksSUFBSSxFQUFFLEdBQ0QsQ0FBQztJQUM1QixDQUFDO0NBQUEifQ==